import React from 'react';
import ArchitectureLayout from 'components/architecture/ArchitectureLayout';
import { getPublicApiGroups } from 'utils/architecture/apiEndpoints';

/**
 * Public APIs Page
 * Lists all public API groups with links to endpoint pages
 */
const PublicAPIs = () => {
  const apiGroups = getPublicApiGroups();

  const sections = [
    {
      id: 'overview',
      title: 'Public APIs',
      content: `The Public APIs enable integrations and public access to platform features. Some APIs require authentication via API keys, while others are publicly accessible.

**Base URLs**: Various (see individual API groups)

**Authentication**: API keys or public access (varies by endpoint)

**Rate Limiting**: Applied per API key or IP address`
    },
    {
      id: 'api-groups',
      title: 'API Groups',
      content: apiGroups.map(group => {
        const endpointLinks = group.endpoints.map(ep => {
          const endpointId = ep.path.replace(/[{}]/g, '').replace(/\//g, '-').toLowerCase();
          return `- [${ep.path}](/architecture/processes/public/endpoints/${endpointId}) - ${ep.methods.join(', ')} - ${ep.description}`;
        }).join('\n');
        
        return `### ${group.name}
${group.description}

**Base Path**: \`${group.basePath}\`

**Endpoints**:
${endpointLinks}`;
      }).join('\n\n')
    },
    {
      id: 'navigation',
      title: 'Navigate to Endpoints',
      content: `Click on any endpoint above to view detailed documentation including:

- Technical description
- Request/response formats
- Authentication requirements
- Error handling
- Links to interactive API documentation`
    }
  ];

  return (
    <ArchitectureLayout
      title="Public APIs"
      lastUpdated="2025-01-15"
      sections={sections}
    />
  );
};

export default PublicAPIs;

